import { cn } from "@/lib/cn";

function Skeleton({
  className,
  variant = "default",
  height,
  width,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  variant?: "default" | "circle" | "text";
  height?: string;
  width?: string;
}) {
  const variantStyles = {
    default: "rounded-md bg-primary/10",
    circle: "rounded-full bg-primary/10",
    text: "rounded-md bg-primary/20 h-4",
  };

  return (
    <div
      className={cn("animate-pulse", variantStyles[variant], className)}
      style={{ height, width }}
      {...props}
    />
  );
}

export { Skeleton };
